const Thunderstorm = (props) => (
  <svg
    width="37"
    height="38"
    viewBox="0 0 37 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.25 35.6238L15.625 23.7488L6.125 20.1863L22.75 2.37378L20.375 14.2488L29.875 17.8113L13.25 35.6238Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Thunderstorm
